<template>
    <div class="freeze-wrap">
        <!--  票券冻结/解冻 -->
        <a-modal
            :visible="visible"
            @cancel="closeModalFreeze"
            :title="`票券${isFreeze ? '冻结' : !isOverFreeze ? '取消冻结' : '解冻'}`"
            :width="650"
            :destroyOnClose="true"
            :confirmLoading="confirmLoading"
            >
            <a-form :form="form" v-if="isFreeze">
                <a-row >
                    <a-col class="text-right" :span="5"> 
                        <a-form-item label="票券当前有效期" ></a-form-item>
                    </a-col>
                    <a-col :span="18" style="line-height: 32px">{{ticketData.validStartTime}} ~ {{ticketData.validEndTime}}</a-col>
                </a-row>
                <a-form-item label="用户缴费金额" :labelCol="{span: 5}" :wrapperCol="{span: 18}">
                    <a-input-number :precision="2" placeholder="请输入" style="width: 100%;" :min="0" v-decorator="['amount',{rules:[{required: true, message: '请输入'}]}]" />
                </a-form-item>
                <a-row>
                    <a-col :span="5" class="text-right">
                        <a-form-item required label="选择冻结期间" >
                        </a-form-item>
                    </a-col>
                    <a-col :span="8">
                        <a-form-item label="">
                            <a-date-picker style="width: 100%" @change="frozenStartDateChange" :disabledDate="disabledDate" v-decorator="['frozenStartDate',{rules:[{required: true, message: '请选择'}]}]" />
                        </a-form-item>
                    </a-col>
                    <a-col :span="2" class="text-center">
                        <span style="line-height: 32px">~</span>
                    </a-col>
                    <a-col :span="8">
                        <a-form-item label="">
                            <a-date-picker style="width: 100%" @change="frozenEndDateChange" :disabledDate="disabledDateEnd" v-decorator="['frozenEndDate',{rules:[{required: true, message: '请选择'}]}]" />
                        </a-form-item>
                    </a-col>
                </a-row>
                <remark :labelSpan="5" :wrapperSpan="18" operateCode="TicketFrozen" />
                <shop :shops="ticketData.suitShopReserveStockConfigs" :labelSpan="5" :wrapperSpan="18"/>
                <div class="mb16" v-if="selectDate">票券冻结天数：{{dateNum}}</div>
                <div class="mb16" v-if="selectDate">票券解冻后有效期：{{selectDate}}</div>
            </a-form>
            
            <section v-else-if="!isFreeze">
                <div>
                    <a-spin :spinning="spinning">
                        <div class="mb16">票券原有效期：{{frozenInfo.originalValidStartTime | timeSplit}} ~ {{frozenInfo.originalValidEndTime | timeSplit}}</div>
                        <div class="mb16">票券当前状态：<span style="color: #EB3B3B">{{ticketData | ticketState}}</span></div>
                        <div class="mb16">冻结缴费金额：{{frozenInfo.amount}} 元</div>
                        <div class="mb16">票券冻结期间：{{frozenInfo.frozenStartTime | timeSplit}} ~ {{frozenInfo.frozenEndTime | timeSplit}}</div>
                        <div class="mb16">票券已冻结天数：{{frozenInfo.frozenDay}} 天</div>
                        <div class="mb16">票券解冻后有效期：{{frozenInfo.nowValidStartTime | timeSplit}} ~ {{frozenInfo.nowValidEndTime | timeSplit}}</div>
                    </a-spin>
                </div>
                <div class="freeze-line"></div>
                <div>
                    <a-radio class="mb16" :checked="isOverFreeze" @click="overFreezeState(true)">票券提前解冻</a-radio>
                    <a-form v-if="isOverFreeze" :form="unfreezeForm">
                        <a-form-item label="选择解冻日期" :labelCol="{span: 5}" :wrapperCol="{span: 18}">
                            <a-date-picker @change="unfreezeChangeDate" :disabledDate="disabledDate2" :allowClear="false" style="width: 100%;" v-decorator="['date',{rules:[{required: true, message: '请选择'}]}]" />
                        </a-form-item>
                        <remark :labelSpan="5" :wrapperSpan="18" operateCode="TicketThaw" />
                        <shop :labelSpan="5" :wrapperSpan="18" :shops="ticketData.suitShopReserveStockConfigs"/>
                        <div class="mb16" v-if="selectDate">票券冻结天数：{{dateNum}}</div>
                        <div class="mb16" v-if="selectDate">票券解冻后有效期：{{selectDate}}</div>
                    </a-form>
                </div>
                <div>
                    <template v-if="ticketData.state !== 10">
                        <a-radio class="mb16" :checked="!isOverFreeze" @click="overFreezeState(false)">取消冻结</a-radio>
                        <span class="text-fail pb16 text-center">
                            <a-icon type="exclamation-circle" /> 取消冻结后，该冻结期不再生效，票券在有效期内始终为正常使用状态
                        </span>
                    </template>
                    <a-form  v-if="!isOverFreeze" :form="preUnfreezeForm">
                        <remark :labelSpan="5" :wrapperSpan="18" operateCode="TicketCancelFrozen" />
                        <shop :shops="ticketData.suitShopReserveStockConfigs" :labelSpan="6" :wrapperSpan="18"/>
                    </a-form>
                </div>
            </section>
            <div class="freeze-line"></div>
            <div class="freeze-rule">
                <p class="mb16">票券冻结规则：</p>
                <p>1.  票券冻结期间只能在票券当前有效期内</p>
                <p>2. 开始冻结时间只能从次日开始选取</p>
                <p>3. 票券解冻日期为票券冻结结束日期</p>
                <p>4. 票券解冻后根据冻结天数，解冻后有效期自动顺延，冻结多少天有效期顺延多少天</p>
                <p>5. 票券若提前解冻，根据实际冻结时间，解冻后有效期顺延，实际冻结多少天顺延多少天</p>
            </div>
            <template slot="footer">
                <div class="text-center pb16">
                    <a-button @click="closeModalFreeze">取消</a-button>
                    <a-button type="primary" @click="comfirm" v-if="isOverFreeze" :loading="confirmLoading">确认</a-button>
                    <a-button type="primary" v-else :loading="confirmLoading" @click="preUnfreeze">确认</a-button>
                </div>
            </template>
        </a-modal>
        <order-pay ref="orderPay" @payCallback="reloadData" :isServeOrder="1"></order-pay>
    </div>
</template>

<script>

    /**
     * 票券冻结组件
     * @prop {Object} ticketData 基础卡对象
     *
     * @func reloadData 通知父组件刷新数据
     *
     */
    import { mapGetters } from "vuex";
    import userInfoTool from "@/plugins/user-info-tool";
    import OrderPay from "@/components/modules/order/order-pay.component";
    import remark from '@/components/modules/platform/remark.component';
    import shop from '@/components/modules/platform/shop.component';

    export default {
        name: "member-order-freeze",
        zh: "日期重置组件",
        components: {
            OrderPay,
            remark,
            shop
        },
        data() {
            return {
                isOverFreeze: true,
                confirmLoading: false,
                visible: false,
                selectDate: "",
                dateNum: 0,
                isFreeze: false,
                frozenInfo: {},
                spinning: false,
                frozenStartDate: null
            };
        },
        filters: {
            timeSplit(val) {
                if (!val) return "-";
                return val.split(" ")[0]
            }
        },
        props: {
            ticketData: {type: Object},
        },
        methods: {
            closeModalFreeze() {
                this.visible = false;
                this.$emit('changeVisibleFreeze', false);
                this.form.resetFields();
            },
            disabledDate(current) {
                return this.today.diff(current) >= 0 || this.$moment(this.ticketData.validEndTime).add(1, 'day').diff(current) <= 0;
            },
            disabledDateEnd(current) {
                return this.$moment().diff(current) >= 0;
            },
            disabledDate2(current) {
                if (!Boolean(current)) {
                    return
                }
                let { frozenEndTime, frozenStartTime } = this.frozenInfo;
                return this.$moment(frozenStartTime).diff(current) >= 0 || this.$moment(frozenEndTime).diff(current) <= 0;
            },
            comfirm() {
                if (this.isFreeze) {
                    // 票券冻结
                    this.form.validateFields((err, values) => {
                        if (err) return;
                        const shopItem = JSON.parse(values.shop);
                        let { phone, userTicketNo, userId } = this.ticketData;
                        delete values.date;
                        delete values.shop;
                        this.confirmLoading = true;
                        this.$api.order.createTicketFrozenOrder({
                            body: {
                                ...values,
                                phone,
                                shopId: shopItem.id,
                                shopName: shopItem.name, 
                                userTicketNo,
                                userId
                            }
                        }).then(res =>{
                            this.$refs.orderPay.orderId = res || "";
                            this.$refs.orderPay.userId = userId;
                            this.visible = false;
                            this.confirmLoading = false;
                            setTimeout(() => {
                                this.$refs.orderPay.visiblePayOrder = true;
                            }, 300)
                        }).catch(err => {
                            this.confirmLoading = false;
                        });
                    });
                } else {
                    // 票券解冻
                    this.unfreezeForm.validateFields((err, values) => {
                        if (err) return;
                        let { frozenObject, frozenStartTime, originalValidityEndTime } = this.frozenInfo;
                        values.thawDate = values.date.format('YYYY-MM-DD');
                        const shopItem = JSON.parse(values.shop);
                        delete values.date;
                        delete values.shop;
                        this.confirmLoading = true;
                        this.$api.order.userTicketThaw({
                            body: {
                                ...values,
                                userId: this.ticketData.userId,
                                phone: this.ticketData.phone,
                                userTicketNo: frozenObject,
                                shopId: shopItem.id,
                                shopName: shopItem.name,
                            }
                        }).then(res =>{
                            this.visible = false;
                            this.confirmLoading = false;
                            setTimeout(() => {
                                this.reloadData();
                            }, 300)
                        }).catch(err => {
                            this.confirmLoading = false;
                        });
                    });
                }
            },
            /**
             * @frozenStartDateChange 冻结开始时间选择回调
             */
            frozenStartDateChange(e) {
                this.frozenStartDate = e;
                let frozenEndDate = this.form.getFieldValue('frozenEndDate');
                this.$nextTick(() => {
                    if (frozenEndDate && e > frozenEndDate) {
                        this.form.setFieldsValue({ frozenEndDate: e });
                        this.form.setFieldsValue({ frozenStartDate: frozenEndDate });
                    }
                    if (frozenEndDate && e) {
                        this.calcFrozenEndInfo();
                    }
                });
            },
            /**
             * @frozenEndDateChange 冻结结束时间选择回调
             */
            frozenEndDateChange(e) {
                let frozenStartDate = this.form.getFieldValue('frozenStartDate');
                this.$nextTick(() => {
                    if (frozenStartDate && e < frozenStartDate) {
                        this.form.setFieldsValue({ frozenStartDate: e });
                        this.form.setFieldsValue({ frozenEndDate: frozenStartDate });
                    }
                    if (frozenStartDate && e) {
                        this.calcFrozenEndInfo();
                    }
                });
            },
            /**
             * @calcFrozenEndInfo 冻结结束时间选择回调
             */
            calcFrozenEndInfo() {
                let frozenStartDate = this.$moment(this.form.getFieldValue('frozenStartDate').format("YYYY-MM-DD 00:00:00"));
                let frozenEndDate = this.$moment(this.form.getFieldValue('frozenEndDate').format("YYYY-MM-DD 23:59:59"));
                let { validEndTime } = this.ticketData;
                if (frozenStartDate && frozenEndDate) {
                    this.dateNum = frozenEndDate.diff(frozenStartDate, 'days') + 1;
                    this.selectDate = frozenEndDate.format('YYYY-MM-DD') + '~' + this.$moment(validEndTime).add(this.dateNum, 'days').format('YYYY-MM-DD');
                }
            },
            /**
             * @unfreezeChangeDate 解冻时间选择回调
             */
            unfreezeChangeDate(e) {
                let { frozenStartTime, originalValidityStartTime, originalValidityEndTime } = this.frozenInfo;
                let frozenStartMoment = this.$moment(frozenStartTime.replace(/\s\S*/, ' 00:00:00'));
                let endThawDate = originalValidityEndTime;
                let unfreezeDate = this.$moment(e.format('YYYY-MM-DD 00:00:00'));
                this.dateNum = unfreezeDate.diff(frozenStartMoment, 'days');
                this.selectDate = e.format('YYYY-MM-DD') + '~' + this.$moment(endThawDate).add(this.dateNum, 'days').format('YYYY-MM-DD');
            },
            /**
             * @reloadData 操作成功回调
             */
            reloadData() {
                this.$emit('reloadData');
            },
            /**
             * @ticketFrozenInfo 票券冻结信息
             */
            ticketFrozenInfo() {
                this.spinning = true;
                this.$api.order.ticketFrozenInfo({
                    params: {
                        userTicketNo: this.ticketData.userTicketNo
                    }
                }).then(res => {
                    this.frozenInfo = res;
                    this.spinning = false;
                }).catch(err => {
                    this.spinning = false;
                })
            },
            /**
             * @preUnfreeze 取消票券冻结
             */
            preUnfreeze() {
                this.preUnfreezeForm.validateFields((errors, values) => {
                    if (Boolean(errors)) {
                        return;
                    }
                    const shopItem = JSON.parse(values.shop);
                    this.confirmLoading = true;
                    this.$api.order.userTicketCancelFrozen({
                        body: {
                            userId: this.ticketData.userId,
                            phone: this.ticketData.phone,
                            userTicketNo: this.ticketData.userTicketNo,
                            remark: values.remark,
                            remarkCategoryCode: values.remarkCategoryCode,
                            remarkCategoryName: values.remarkCategoryName,
                            shopId: shopItem.id,
                            shopName: shopItem.name,
                        }
                    }).then(res => {
                        this.confirmLoading = false;
                        this.visible = false;
                        this.$message.success('操作成功！');
                        setTimeout(() => {
                            this.reloadData();
                        }, 300)
                    }).catch(err => {
                        this.confirmLoading = false;
                    });
                })
            },
            /**
             * @overFreezeState 是否提前解冻状态更改
             */
            overFreezeState(state) {
                this.isOverFreeze = state;
            },
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
            this.unfreezeForm = this.$form.createForm(this);
            this.preUnfreezeForm = this.$form.createForm(this);
            this.today = this.$moment(this.$moment().format('YYYY-MM-DD 00:00:00')).add(1, 'day');
            this.loginInfo = {
                shopId: sessionStorage.getItem('currentShopId'),
                shopName: sessionStorage.getItem('currentShopName'),
            }
        },
        created() {},
        updated() {},
        mounted() {
        },
        computed: {
            ...mapGetters(["shopId"])
        },
        watch: {
            'shopId'(val) {
                this.loginInfo = {
                    shopId: sessionStorage.getItem('currentShopId'),
                    shopName: sessionStorage.getItem('currentShopName'),
                }
            },
            'ticketData'(val) {
                this.ticketData = val
            },
            visible(val) {
                if (!val) {
                    setTimeout(() => {
                        this.isOverFreeze = true;
                        this.confirmLoading = false;
                        this.visible = false;
                        this.selectDate = "";
                        this.dateNum = 0;
                        this.isFreeze = false;
                        this.frozenInfo = {};
                        this.spinning = false;
                    }, 300);
                }
            }
        }
    };
</script>

<style lang="scss">
    .freeze-line {
        width: 100%;
        height: 1px;
        background: #EEE;
        margin-bottom: 14px;
    }
    .freeze-rule {
        p {
            margin-bottom: 0;
            color: rgba(0,0,0,0.45);
        }
        p:first-child {
            font-size: 14px;
            font-weight: 500;
            color: rgba(0,0,0,0.85);
        }
    }
    .freeze-wrap-pop {
        p:empty {
            width: 372px;
            height: 1px;
            background: #EEE;
            &:nth-child(1) {
                margin-top: 16px;
            }
        }
    }
    .mypop {
        .ant-popover {
            left: 72.5px!important;
            top: -49px!important;
            transform-origin: 404px 289px!important;
        }
        .ant-popover-message-title {
            padding-left: 0;
        }
    }
</style>
